import React from 'react';

export interface IImage {
	src: string;
	alt?: string;
	width: number;
	height: number;
	/**
	 * @noUI
	 */
	srcSets?: string;
}

export interface IImageProps extends IImage {
	className?: string;
}

const Image: React.FC<IImageProps> = ({
	src,
	alt = '',
	width,
	height,
	className,
	srcSets,
}) => {
	return (
		<img
			src={src}
			alt={alt}
			width={width}
			height={height}
			className={className || ''}
			srcSet={srcSets ? srcSets : undefined}
		/>
	);
};
export default Image;
